module.exports = {
	// Listed in order of usage preference
	'localStorage': require('./localStorage'),
	'oldFF-globalStorage': require('./oldFF-globalStorage'),
	'oldIE-userDataStorage': require('./oldIE-userDataStorage'),
	'cookieStorage': require('./cookieStorage'),
	'sessionStorage': require('./sessionStorage'),
	'memoryStorage': require('./memoryStorage'),
}



//////////////////
// WEBPACK FOOTER
// ./~/store/storages/all.js
// module id = 189
// module chunks = 0